import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as DeviceErrorIcon } from '../../../../../../../../assets/dashboard/DeviceError.svg';
import {
  ILabelValuePanel,
  IFlexeserveDeviceConnectionErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAirConnectStatusCount from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatusCount';

export interface FlexeserveDeviceConnectionErrorPanelProps {
  panel: IFlexeserveDeviceConnectionErrorPanel;
  layout?: LayoutItem | undefined;
}

function FlexeserveDeviceConnectionErrorPanel(
  props: FlexeserveDeviceConnectionErrorPanelProps
) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isLoading, currentData, error } = useAirConnectStatusCount(panel);
  const value = currentData?.nodeLost ?? 0;

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `flexeserve_device_connection_error`,
    title: panel.title,
    icon: <DeviceErrorIcon height={'100%'} />,
    content: (
      <DefaultRightContainer success={value === 0}>
        {value}
      </DefaultRightContainer>
    ),
    loading: isLoading,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default FlexeserveDeviceConnectionErrorPanel;
